// extracted by mini-css-extract-plugin
export default {"form":"SearchBar_form__gW7Gj","input":"SearchBar_input__bIy50","btn":"SearchBar_btn__PKGSc"};